import React, { Component } from 'react'

import './SwitchingsList.css'

/**
 * Modulos
 */
import { Form, Select, Spin, Tabs, Collapse, Avatar } from 'antd';
import { getSwitchingsFromChamp, getRotationsFromChamp } from '../../../utils/confrontationsFunctions';

/**
 * Components
 */
import SwitchingContainer from '../sharedSwitching/SwitchingContainer';
import SwitchingSpecialContainer from '../sharedSwitchingSpecial/SwitchingSpecialContainer';
import RotationContainer from '../sharedRotation/RotationContainer';
;

class SwitchingsList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            switchingList: [],
            switchingListLoading: false,
            switchingListFiltered: [],

            switchingSpecialList: [],
            switchingSpecialListLoading: false,
            rotationListFiltered: [],

            rotationList: [],
            rotationListLoading: false,

            switchingObjList: [],
            switchingSpecialObjList: [],
            rotationObjList: [],

            showListFlag: 'block',
            showSpinFlag: 'none',

            indexOfSwitching: 0,
            modalSwitching: false,
            modalSpecialSwitching: false,
            modalRotation: false,
        }
    }

    // componentWillMount = () => {
    //     this.componentWillReceiveProps(this.props)
    // }

    // componentWillReceiveProps = (nextProps) => {
    //     let form = nextProps.form

    //     if(nextProps.clearInputs)
    //         form.resetFields()

    //     if(!form.getFieldValue('sexo') && !form.getFieldValue('faixa')){
    //         /* Create array to list of switching/rotation */
    //         let localSwitchingArray = [], localRotationArray = [], localSwitchingSpecialArray = []
    //         for(let i = 1; i <= 300; i++){
    //             localSwitchingArray.push(i)
    //             if(i <= 20){
    //                 localRotationArray.push('Rodízio '+ i)
    //                 if(i <= 5)
    //                     localSwitchingSpecialArray.push(i)
    //             }
    //         }
    //         this.setState({
    //             switchingList: localSwitchingArray,
    //             rotationList: localRotationArray,
    //             switchingSpecialList: localSwitchingSpecialArray,
    //             champInfo: nextProps.champInfo
    //         })
    //     } else {
    //         /* Hide list while get from database */
    //         this.setState({ showSpinFlag: 'block', showListFlag: 'none' })

    //         /* Get list filtered from database */
    //         let localSwitchingArray = [], localRotationArray = [], localSwitchingSpecialArray = []
    //         firebase.database().ref('champs/' + nextProps.champInfo.__key + '/switching').once('value')
    //         .then(switchings => {
    //             switchings.forEach(switching => {
    //                 let localObj = switching.val()
    //                 localObj['__key'] = switching.key
    //                 if(switching.key <= 100)
    //                     localSwitchingArray.push(localObj)
    //                 else
    //                     localSwitchingSpecialArray.push(localObj)
    //             })
    //             return true
    //         })
    //         .then(() => {
    //             firebase.database().ref('champs/' + nextProps.champInfo.__key + '/rotation').once('value')
    //             .then(rotations => {
    //                 rotations.forEach(rotation => {
    //                     let localObj = rotation.val()
    //                     localObj['__key'] = rotation.key
    //                     localRotationArray.push(localObj)
    //                 })

    //                 return true
    //             })
    //             .then(() => {
    //                 new Promise((resolve) => {
    //                     resolve(
    //                         this.setState({
    //                             switchingObjList: localSwitchingArray,
    //                             switchingSpecialObjList: localSwitchingSpecialArray,
    //                             rotationObjList: localRotationArray
    //                         })
    //                     )
    //                 })
    //                 .then(() => {
    //                     if(form.getFieldValue('sexo'))
    //                         this.filter('sexo')

    //                     if(form.getFieldValue('faixa'))
    //                         this.filter('faixa')
    //                 })
    //             })
    //         })
    //     }
    // }

    componentDidMount = () => {
        this.getAllSwitching(this.props.champId);
        this.getAllRotation(this.props.champId);
    }

    getAllSwitching = async (key) => {
        this.setState({
            switchingList: [],
            switchingListLoading: true
        })

        /* Get all switchings */
        let localArray = await getSwitchingsFromChamp(key);

        this.setState({
            switchingList: localArray,
            switchingListFiltered: localArray,
            switchingListLoading: false
        });
    }

    getAllRotation = async (key) => {
        this.setState({
            rotationList: [],
            rotationListLoading: true
        });

        /* Get all rotation */
        let localArray = await getRotationsFromChamp(key);

        this.setState({
            rotationList: localArray,
            rotationListFiltered: localArray,
            rotationListLoading: false
        });
    }

    filter = (value) => {
        let localSwitchingArray = [], localRotationArray = [], localSwitchingSpecialArray = []

        // eslint-disable-next-line
        this.state.switchingObjList.map(switching => {
            if (switching[value] === this.props.form.getFieldValue(value))
                localSwitchingArray.push(switching.__key)
        })

        // eslint-disable-next-line
        this.state.switchingSpecialObjList.map(switching => {
            if (switching[value] === this.props.form.getFieldValue(value))
                localSwitchingSpecialArray.push(switching.__key)
        })

        // eslint-disable-next-line
        this.state.rotationObjList.map(rotation => {
            if (rotation[value] === this.props.form.getFieldValue(value))
                localRotationArray.push(rotation.__key)
        })

        this.setState({
            switchingList: localSwitchingArray,
            switchingSpecialList: localSwitchingSpecialArray,
            rotationList: localRotationArray,

            /* show list and hide spin */
            showSpinFlag: 'none',
            showListFlag: 'block'
        })
    }

    openSwitModal = (switchOrRot, key) => {
        this.setState({
            modalSwitching: (switchOrRot === 'switching' ? true : false),
            modalSpecialSwitching: (switchOrRot === 'specialSwitching' ? true : false),
            modalRotation: (switchOrRot === 'rotation' ? true : false),
            indexOfSwitching: key
        })
    }

    closeSwitModal = () => {
        this.setState({
            modalSwitching: false,
            modalSpecialSwitching: false,
            modalRotation: false
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form>
                    <Form.Item style={{ width: '49%', float: 'left', marginRight: '2%' }}>
                        {getFieldDecorator('sexo')(
                            <Select
                                showSearch
                                placeholder="Filtrar Sexo"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todos</Select.Option>
                                <Select.Option value="Masculino">Masculino</Select.Option>
                                <Select.Option value="Feminino">Feminino</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', float: 'left' }}>
                        {getFieldDecorator('faixa')(
                            <Select
                                showSearch
                                placeholder="Filtrar Faixa do aluno"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}>Todas</Select.Option>
                                <Select.Option value="whiteSmoke">Branca</Select.Option>
                                <Select.Option value="grey">Cinza</Select.Option>
                                <Select.Option value="yellow">Amarela</Select.Option>
                                <Select.Option value="orange">Laranja</Select.Option>
                                <Select.Option value="green">Verde</Select.Option>
                                <Select.Option value="#ffcc99">Colorido</Select.Option>
                                <Select.Option value="blue">Azul</Select.Option>
                                <Select.Option value="purple">Roxa</Select.Option>
                                <Select.Option value="brown">Marrom</Select.Option>
                                <Select.Option value="black">Preta</Select.Option>
                            </Select>
                        )}
                    </Form.Item>
                </Form>

                <div style={{ clear: 'both' }}></div>

                <div style={{ display: this.state.showSpinFlag, width: '100%', textAlign: 'center' }}>
                    <Spin />
                </div>
                <div style={{ display: this.state.showListFlag }}>
                    <Tabs defaultActiveKey="1">

                        <Tabs.TabPane tab="Chaves" key="1">
                            <Collapse>
                                {
                                    (this.state.switchingList || []).map((item, index) => {
                                        if (index < 308) {
                                            return (
                                                <Collapse.Panel
                                                    header={
                                                        <div>
                                                            Chave {item && item.__key} |&nbsp;
                                                            <Avatar style={{ backgroundColor: item.faixa }} size='small' shape='square' />&nbsp;
                                                            <span style={{ fontSize: 'x-small' }}>
                                                                {item.sexo} {item.idade}
                                                            </span>
                                                        </div>
                                                    }
                                                    key={index}
                                                    extra={
                                                        <div>
                                                        </div>
                                                    }
                                                >
                                                    <SwitchingContainer
                                                        switching={item}
                                                    />
                                                </Collapse.Panel>
                                            );
                                        }
                                        return null;
                                    })
                                }
                            </Collapse>
                            {/* <List
                                locale={{ emptyText: 'Nenhuma chave encontrada' }}
                                bordered
                                dataSource={this.state.switchingList}
                                renderItem={item => (<List.Item style={{ cursor: 'pointer' }} onClick={() => this.openSwitModal('switching', item.index)}>Chave {item.__key}</List.Item>)}
                                style={{ marginBottom: '20px' }}
                            /> */}
                        </Tabs.TabPane>

                        <Tabs.TabPane tab="Chaves especiais" key="2">
                            <Collapse>
                                {
                                    (this.state.switchingList || []).map((item, index) => {
                                        if (index >= 308) {
                                            return (
                                                <Collapse.Panel header={`Chave especial ${(item && item.index) - 308}`} key={index}>
                                                    <SwitchingSpecialContainer
                                                        switching={item}
                                                    />
                                                </Collapse.Panel>
                                            );
                                        }
                                        return null;
                                    })
                                }
                            </Collapse>
                            {/* <List
                                locale={{ emptyText: 'Nenhuma chave encontrada' }}
                                bordered
                                dataSource={this.state.switchingSpecialList}
                                renderItem={item => (<List.Item style={{ cursor: 'pointer' }} onClick={() => this.openSwitModal('specialSwitching', item)}>Chave Especial {item}</List.Item>)}
                                style={{ marginBottom: '20px' }}
                            /> */}
                        </Tabs.TabPane>

                        <Tabs.TabPane tab="Rodízios" key="3">
                            <Collapse>
                                {
                                    (this.state.rotationList || []).map((item, index) => {
                                        return (
                                            <Collapse.Panel header={`Rodízio ${item && item.index}`} key={index}>
                                                <RotationContainer
                                                    rotation={item}
                                                    champObject={this.state.champInfo}
                                                />
                                            </Collapse.Panel>
                                        );
                                    })
                                }
                            </Collapse>
                            {/* <List
                                locale={{ emptyText: 'Nenhum rodízio encontrado' }}
                                bordered
                                dataSource={this.state.rotationList}
                                renderItem={item => (<List.Item style={{ cursor: 'pointer' }} onClick={() => this.openSwitModal('rotation', item.__key)}>{item.__key}</List.Item>)}
                            /> */}
                        </Tabs.TabPane>

                    </Tabs>

                </div>

                {/* <Modal
                    title={'Chave ' + this.state.indexOfSwitching}
                    visible={this.state.modalSwitching}
                    onCancel={this.closeSwitModal}
                    width={1250}
                    footer={[
                        <Button key='close' onClick={this.closeSwitModal}>Fechar</Button>
                    ]}
                >
                    <SwitchingContainer
                        idOfSwitching={this.state.indexOfSwitching}
                        champObject={this.props.champInfo}
                        switching={this.state.switchingList[this.state.indexOfSwitching]}
                    />
                    <div style={{ clear: 'both' }}></div>
                </Modal>

                <Modal
                    title={'Chave Especial ' + this.state.indexOfSwitching}
                    visible={this.state.modalSpecialSwitching}
                    onCancel={this.closeSwitModal}
                    width={900}
                    footer={[
                        <Button key='close' onClick={this.closeSwitModal}>Fechar</Button>
                    ]}
                >
                    <SwitchingSpecialContainer
                        idOfSwitching={308 + this.state.indexOfSwitching}
                        champObject={this.props.champInfo}
                    />
                    <div style={{ clear: 'both' }}></div>
                </Modal>

                <Modal
                    title={'Rodízio ' + this.state.indexOfSwitching}
                    visible={this.state.modalRotation}
                    onCancel={this.closeSwitModal}
                    width={900}
                    footer={[
                        <Button key='close' onClick={this.closeSwitModal}>Fechar</Button>
                    ]}
                >
                    <RotationContainer
                        idOfRotation={this.state.indexOfSwitching}
                        champObject={this.state.champInfo}
                    />
                    <div style={{ clear: 'both' }}></div>
                </Modal> */}
            </div>
        )
    }

}

export default Form.create()(SwitchingsList)